import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import BasicAreaLineChart from 'components/common/chart/BasicAreaLineChart';
import { ReactComponent as SolarSvg } from '../../../../assets/icons/solar.svg';

const SolarPanel = () => {
  const data = [
    520, 780, 1170, 1300, 1560, 1560, 1430, 1300, 1170, 910, 650, 650
  ];
  return (
    <>
      <Col md={12} className="border-bottom pb-2">
        <Row className="mx-0">
          <Col xs={6} className="py-2 centered-column">
            <h6 className="text-600">Total Solar Panels</h6>
            <SolarSvg className="land-dev-icon-40 mb-1" />
            <h5 className="fw-normal text-500 mb-0">1</h5>
          </Col>
          <Col xs={6} className="pb-2">
            <Flex justifyContent="between" alignItems="center" className="py-2">
              <h6 className="text-600 mb-0">Area Covered</h6>
              <h5 className="fw-normal text-500 mb-0">60 m2</h5>
            </Flex>
            <Flex justifyContent="between" alignItems="center" className="py-2">
              <h6 className="text-600 mb-0">Capacity Installed</h6>
              <h5 className="fw-normal text-500 mb-0">10 kW</h5>
            </Flex>
            <Flex justifyContent="between" alignItems="center" className="pt-2">
              <h6 className="text-600 mb-0">Energy Generated</h6>
              <h5 className="fw-normal text-500 mb-0">13,000 kW</h5>
            </Flex>
          </Col>
        </Row>
      </Col>
      <Col md={12} className="border-bottom py-2 height-22">
        <Row className="mx-0">
          <h6 className="text-600 mb-0">Annunal Energy Output (kWh)</h6>
          <BasicAreaLineChart data={data} />
        </Row>
      </Col>
      <Col md={12} className="py-2">
        <Flex justifyContent="between" alignItems="center" className="py-2">
          <h6 className="text-600 mb-0">Initial Cost</h6>
          <h6 className="text-600 mb-0">$ 12,000</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Annunal Maintenance Cost</h6>
          <h6 className="text-600 mb-0">$ 200</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center" className="mb-2">
          <h6 className="text-600 mb-0">Carbon Avoided</h6>
          <h6 className="text-600 mb-0">5.48 tCO2e</h6>
        </Flex>
        <Flex justifyContent="between" alignItems="center">
          <h6 className="text-600 mb-0">Carbon Credit Revenue</h6>
          <h6 className="text-600 mb-0">$ 274</h6>
        </Flex>
      </Col>
    </>
  );
};
export default SolarPanel;
